import { connect } from 'react-redux';
import {
  getAccessories,
  getAddedProducts,
  getCornerPostAccessories,
  getInputDataToSend,
  getTreeStructureSettings,
} from '../../../../../../../store/form/selectors';
import NestedAccessory from './NestedAccessory';
import { fetchProductsBySection, setTreeStructureSettings } from '../../../../../../../store/form/actions';
import { getModals } from '../../../../../../../store/modals/selectors';
import { setOpenModal } from '../../../../../../../store/modals/actions';

const mapStateToProps = (state) => ({
  accessories: getAccessories(state),
  cornerPostAccessories: getCornerPostAccessories(state),
  modals: getModals(state),
  inputData: getInputDataToSend(state),
  addedProducts: getAddedProducts(state),
  treeStructureSettings: getTreeStructureSettings(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchProductsBySection: (
    fetchSettings,
  ) => {
    dispatch(fetchProductsBySection(
      fetchSettings,
    ));
  },

  setTreeStructureSettings: (level, parentId, parentName) => dispatch(
    setTreeStructureSettings(level, parentId, parentName),
  ),

  setOpenModal: (modal, value) => dispatch(
    setOpenModal(modal, value),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(NestedAccessory);
